import { Timestamp, doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { clearPendingGuestIntakeState, getPendingGuestIntake } from './guestIntake';

function buildConsentTimestamp(acceptedAt) {
  const acceptedDate = new Date(acceptedAt);

  if (Number.isNaN(acceptedDate.getTime())) {
    return serverTimestamp();
  }

  return Timestamp.fromDate(acceptedDate);
}

export async function syncPendingGuestIntake(user) {
  if (!db || !user) {
    return false;
  }

  const guestIntake = getPendingGuestIntake();

  if (!guestIntake) {
    return false;
  }

  const name = guestIntake.name?.trim() || user.displayName?.trim() || '';
  const email = user.email?.trim() || guestIntake.email?.trim() || '';
  const phone = guestIntake.phone?.trim() || '';
  const preferredLanguage =
    guestIntake.preferredLanguage?.trim() || guestIntake.language?.trim() || '';
  const situationDescription =
    guestIntake.situationDescription?.trim() ||
    guestIntake.description?.trim() ||
    guestIntake.message?.trim() ||
    '';
  const consentRecordId = guestIntake.consentRecordId?.trim() || '';
  const consentAcceptedAt = guestIntake.consentAcceptedAt?.trim() || '';
  const consentLanguage = guestIntake.consentLanguage?.trim() || '';
  const termsVersion = guestIntake.termsVersion?.trim() || '';
  const privacyVersion = guestIntake.privacyVersion?.trim() || '';

  const userUpdate = {
    userId: user.uid,
    profileComplete: true,
    consentToContact: true,
    consentAcceptedAt: buildConsentTimestamp(consentAcceptedAt),
    updatedAt: serverTimestamp(),
  };

  if (consentRecordId) {
    userUpdate.consentRecordId = consentRecordId;
  }

  if (consentLanguage) {
    userUpdate.consentLanguage = consentLanguage;
  }

  if (termsVersion) {
    userUpdate.termsVersion = termsVersion;
  }

  if (privacyVersion) {
    userUpdate.privacyVersion = privacyVersion;
  }

  if (email) {
    userUpdate.email = email;
  }

  if (name) {
    userUpdate.name = name;
  }

  if (phone) {
    userUpdate.phone = phone;
  }

  if (preferredLanguage) {
    userUpdate.preferredLanguage = preferredLanguage;
  }

  if (situationDescription) {
    userUpdate.description = situationDescription;
    userUpdate.situationDescription = situationDescription;
  }

  const intakeUpdate = {
    intakeComplete: true,
    consentToContact: true,
    consentAcceptedAt: buildConsentTimestamp(consentAcceptedAt),
    updatedAt: new Date().toISOString(),
  };

  if (consentRecordId) {
    intakeUpdate.consentRecordId = consentRecordId;
  }

  if (consentLanguage) {
    intakeUpdate.consentLanguage = consentLanguage;
  }

  if (termsVersion) {
    intakeUpdate.termsVersion = termsVersion;
  }

  if (privacyVersion) {
    intakeUpdate.privacyVersion = privacyVersion;
  }

  if (email) {
    intakeUpdate.email = email;
  }

  if (name) {
    intakeUpdate.name = name;
  }

  if (phone) {
    intakeUpdate.phone = phone;
  }

  if (preferredLanguage) {
    intakeUpdate.preferredLanguage = preferredLanguage;
  }

  if (situationDescription) {
    intakeUpdate.situationDescription = situationDescription;
  }

  try {
    await Promise.all([
      setDoc(doc(db, 'users', user.uid), userUpdate, { merge: true }),
      setDoc(doc(db, 'intake', user.uid), intakeUpdate, { merge: true }),
    ]);

    clearPendingGuestIntakeState();
    return true;
  } catch {
    return false;
  }
}
